import H from 'constants/httpMethod.const';
import { fromCreateFeeToDto } from 'dto/taxes/fromFeeToDto.dto';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beCreateFee = actionEndpointBe('beCreateFee', H.post, 'sales/salon/:salonId/fees/', (options, extra) => ({
  ...options,
  inert: true,
  data: extra?.data,
  toDto: fromCreateFeeToDto,
}));
